import { render, staticRenderFns } from "./ContactsSupplyChart.vue?vue&type=template&id=5a877a73&scoped=true"
import script from "./ContactsSupplyChart.vue?vue&type=script&lang=js"
export * from "./ContactsSupplyChart.vue?vue&type=script&lang=js"
import style0 from "./ContactsSupplyChart.vue?vue&type=style&index=0&id=5a877a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a877a73",
  null
  
)

export default component.exports